import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

const MySwal = withReactContent(Swal);

export const handleConfirmSwal = async (message = '') => {
  return MySwal.fire({
    text: message,
    confirmButtonText: 'Sí',
    showConfirmButton: true,
    showCancelButton: true,
    cancelButtonColor: '#d33',
    icon: 'warning',
    customClass: {
      container: 'gap: 100px',
    },
  });
};
export const handleErrorSwal = async (
  message = 'Ocurrió un error inesperado. Por favor, recargue la página. Si el problema persiste, contacte a nuestro equipo de soporte.',
) => {
  return MySwal.fire({
    title: 'Error',
    text: message,
    icon: 'error',
    confirmButtonText: 'OK',
  });
};
export const handleSuccesSwal = async (message = '') => {
  return MySwal.fire({
    title: 'Operación completada exitosamente',
    text: message,
    icon: 'success',
    confirmButtonText: 'OK',
  });
};
export const handleWarningSwal = async (message = '') => {
  return MySwal.fire({
    title: 'Atención',
    text: message,
    icon: 'warning',
    confirmButtonText: 'OK',
  });
};
